module.exports = __webpack_public_path__ + "static/media/event_add_black.f51f4884.svg";